import { useEffect } from 'react';
import { useStore } from 'hooks';
import { useTour } from '../use-tour';
import { HOUSE_CHATS_ONBOARDING_TOUR_ID } from './tour.config';
import { toast } from 'components/ui';
import { TOUR_REGISTRY } from '../tour.registry';

export const useHouseChatsTour = (enabled?: boolean) => {
  const { startTour, persistence } = useTour();
  const { onboardings, user } = useStore();

  useEffect(() => {
    if (
      persistence.hasSeen(HOUSE_CHATS_ONBOARDING_TOUR_ID, user.id) ||
      !enabled
    ) {
      return;
    }

    const tour = TOUR_REGISTRY[HOUSE_CHATS_ONBOARDING_TOUR_ID];

    const id = toast({
      title: 'Новый раздел «Домовые чаты»',
      description:
        'Теперь можно переписываться с жителями, не открывая MAX отдельно — всё в одном месте.',
      actions: {
        acceptLabel: 'Показать, как это работает',
        cancelLabel: 'Пропустить',
        onAccept: () => startTour(HOUSE_CHATS_ONBOARDING_TOUR_ID),
        onCancel: () =>
          onboardings.patchOnboardingInfo(
            {
              block: HOUSE_CHATS_ONBOARDING_TOUR_ID,
              viewed: true,
              version: tour.version,
            },
            user.id
          ),
      },
    });

    return () => {
      toast.dismiss(id);
    };
  }, [enabled]);
};
